var Personagens;

(function($){

    Personagens = {

        $ : null,
        $wrapper : null,
        $scroller : null,
        editoria : false,
        scrollLeft : 0,
        timeSize : null,
        timePosition : null,
        isMobile : null,

        init : function(){

            this.$ = $( '.slider-personagens' );
            if( !this.$.length ) return true;

            this.$scroller = $( '.slider', this.$ );
            this.$list = this.$scroller.children( 'div' );
            this.$model = this.$list.children( 'div.teaser' ).clone();
            this.editoria = this.$.data( 'editoria' );
            this.isMobile = ( Utils.getPageWidth() <= 500 );

            Personagens.configure();

        },

        configure : async function(){

            // Remove model
            Personagens.$list.children( 'div.teaser' ).remove();

            // Request items
            var items = await Personagens.requestItems( Personagens.editoria );
            
            // There is no items
            if( !items || !Object.keys( items ).length ){

                const $banner = this.$.parents( '.banner-personagens' );
                if( $banner.length ){
                    $banner.first().remove();
                }
                else {
                    Personagens.$.remove();
                }

            } 

            $.each( items, function( index, item ){

                let $newItem = Personagens.$model.clone().appendTo( Personagens.$list );

                // Link
                $newItem.find( 'a' ).attr( 'href', item.url );

                // Header
                const $header = $( '.header', $newItem );
                $header.find( 'h4' ).html( item.nome );
                $header.find( 'em' ).html( item.ufcidade );

                // Image
                if( item.foto ){
                    $picture = $( item.foto.replace( '<img ', '<img loading="lazy" ' ) ).appendTo( $header );
                    $picture.find( 'img' ).attr( 'alt', item.nome );
                }

                // Content
                const $content = $( '.content', $newItem );
                $content.find( 'em' ).html( item.negocio );
                $content.find( 'strong' ).html( item.ufcidade )

                // Text
                if( item.desc ){

                    if( item.desc.length <= 280 ){
                        $content.find( 'p' ).html( item.desc );
                    }
                    else {

                        // Trim
                        let desc = item.desc.substr( 0, 280 ).split( ' ' );
                        desc.pop();
                        desc = desc.join( ' ' );

                        // Remove last char accents
                        const lastChar = desc.substring( desc.length - 1 );
                        if( lastChar === ',' || lastChar === '.' || lastChar === ':' || lastChar === '!' || lastChar === '?' || lastChar === '-' || lastChar === '_' || lastChar === '/' || lastChar === '\\' ){
                            desc = desc.substring( 0, desc.length - 1 );
                        }

                        // Insert text
                        $content.find( 'p' ).html( desc + '...' );

                    }

                }

                if( !Personagens.isMobile ){
                    $newItem.hover(
                        function(){
                            Personagens.checkSize();
                        },
                        function(){
                            Personagens.checkSize();
                        }
                    );
                }
                
            });

            // Get items
            this.$items = $( '.teaser', Personagens.$list );

            // Mobile
            if( Personagens.isMobile ){

                // Start slider
                Personagens.startSlick();

            }
            // Desktop
            else {

                // Drag scroll start
                this.$scroller.addClass( 'dragscroll' );

                // Bind item click
                this.$list.on( 'mousedown', '.teaser', function(e){
                    Personagens.scrollLeft = Personagens.$scroller.scrollLeft();
                });
                // Bind item click
                this.$list.on( 'click', '.teaser', function(e){

                    var scrollLeft = Personagens.$scroller.scrollLeft();

                    e.target.$ = e.target.$ || $( e.target );
                    e.target.$h = e.target.$h || e.target.$.parents( '.header' );

                    if( e.target.$.hasClass( 'header' ) || e.target.$h.length ){

                        e.preventDefault();

                        if( scrollLeft <= ( Personagens.scrollLeft + 20 ) && scrollLeft >= ( Personagens.scrollLeft - 20 ) ){
                            Personagens.toggleItem( this );
                        }

                    }
                    
                });

                // Bind scroll
                this.$scroller.scroll(function(){
                    if( Personagens.timePosition ) clearTimeout( Personagens.timePosition );
                });

                Personagens.calculaWidth();

            }

        },
        
        startSlick : function(){

            Personagens.$controls = $( '<div class="controls"></div>' ).prependTo( Personagens.$scroller ); 
            Personagens.$overview = $( '<em></em>' ).appendTo( Personagens.$controls );
            Personagens.$arrows = $( '<nav></nav>' ).appendTo( Personagens.$controls );

            Personagens.$list.on( 'init', function( event, slick, currentSlide ){
                Personagens.setOverview( slick );
            });
            Personagens.$list.on( 'afterChange', function( event, slick, currentSlide ){
                Personagens.setOverview( slick );
            });

            // Slick start
            Personagens.$list.slick({
                infinite: false,
                waitForAnimate: false,
                appendArrows: Personagens.$arrows
            });

        },

        setOverview : function( slick ){
            Personagens.$overview.html( '<strong>' + ( slick.currentSlide + 1 ) + '</strong>/' + slick.slideCount );
        },

        toggleItem : function( item ){

            item.$ = item.$ || $( item );
            
            if( item.$.hasClass( 'active' ) ){
                Personagens.deactivateItem( item );
            }
            else {
                Personagens.activateItem( item );
            }
        },

        activateItem : function( item ){

            Personagens.$items.removeClass( 'active' );

            item.$ = item.$ || $( item );
            item.$.addClass( 'active' );

            // Check wrapper size
            Personagens.checkSize();

            if( Personagens.timePosition ) clearTimeout( Personagens.timePosition );
            Personagens.timePosition = setTimeout(function(){
                Personagens.checkPosition();
            }, 720 );

        },

        deactivateItem : function( item ){

            item.$ = item.$ || $( item );
            item.$.removeClass( 'active' );

            // Cancel position check
            if( Personagens.timePosition ) clearTimeout( Personagens.timePosition );

            // Check wrapper size
            Personagens.checkSize();
        
        },

        checkPosition : function(){

            const $active = this.$items.filter( '.active' );
            if( !$active.length ) return true;

            const 
                width = $active.outerWidth( true ),
                areaWidth = Personagens.$scroller.outerWidth(),
                scrollLeft = Personagens.$scroller.scrollLeft()
            ;

            var postLeft = 0;
            $active.prevAll().each(function(){
                this.$ = this.$ || $( this );
                postLeft += this.$.outerWidth( true );
            });
            
            // Left hide
            if( scrollLeft > postLeft ){
                Personagens.$scroller.stop( true, true ).scrollLeft( postLeft );
            }
            // Right hide
            const 
                rightPoint = postLeft + width + 16,
                neededScroll = rightPoint - areaWidth
            ;
            if( neededScroll > 0 && scrollLeft < neededScroll ){
                Personagens.$scroller.stop( true, true ).scrollLeft( neededScroll );
            }
            
        },

        checkSize : function(){

            if( Personagens.timeSize ) clearTimeout( Personagens.timeSize );
            Personagens.timeSize = setTimeout(function(){
                Personagens.calculaWidth();
            }, 510 );
        
        },

        // Set wrapper size
        calculaWidth : function(){

            var total = 0;
            Personagens.$items.each(function(){
                this.$ = this.$ || $( this );
                total += this.$.outerWidth( true );
            });
            
            if( total < this.$scroller.outerWidth() ){
                Personagens.$.addClass( 'no-scroll' );
                Personagens.$list.css( 'width', 'auto' );
            }
            else {
                Personagens.$.removeClass( 'no-scroll' );
                Personagens.$list.css({ 
                    'width': ( total + 'px' ),
                    'min-width': ( total + 'px' )
                });
            }
        
        },

        requestItems : async function( editoria ){            
            return new Promise(function( resolve, reject ) {
                $.ajax({
                    //url: 'https://cliente.pikiweb.com/wp-json/wp/v2/historia' + ( editoria ? '?editoria=' + editoria : '' ),
                    url: 'https://personagenssebrae.com.br/wp-json/wp/v2/historia' + ( editoria ? '?editoria=' + editoria : '' ),
                    type: 'GET',
                    dataType: 'JSON',
                    success: function( data ){
                        resolve(data);
                    },
                    error: function( err ){
                        reject(err);
                    }
                });
            });
        }

    };

    document.addEventListener( 'DOMContentLoaded', function(){
        Personagens.init(); 
    });

})(jQuery);
